function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0F82B7",
  d: "M169.274 156.029c-12.585-12.584-29.962-20.377-49.122-20.377-19.162 0-36.539 7.793-49.123 20.377l-27.727-27.727c19.689-19.688 46.873-31.885 76.85-31.885 29.977 0 57.16 12.197 76.85 31.885l-27.728 27.727zm-80.563 17.682l31.441 31.441 31.441-31.441c-8.047-8.043-19.163-13.02-31.441-13.02-12.279 0-23.394 4.977-31.441 13.02zm31.441-99.328c36.053 0 68.746 14.664 92.424 38.346l27.729-27.727c-30.784-30.785-73.284-49.85-120.152-49.85-46.87 0-89.37 19.065-120.153 49.85l27.728 27.727C51.406 89.047 84.1 74.383 120.152 74.383z",
  className: "prefix__active-path",
  "data-old_color": "#000000",
  "data-original": "#000000"
});

var SvgWifiConnection = function SvgWifiConnection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    enableBackground: "new 0 0 240.305 240.305",
    viewBox: "0 0 240.305 240.305",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWifiConnection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wifi-connection.91ab7268.svg";
export { ForwardRef as ReactComponent };